export default "https://cdn.questicon.mathletics.com/assets/audio/selfAssesmentEmojis_1-71a2e5fb41535aa6eba592723f281216.mp3";